import HeroBg from "public/nocSoc/Network_ NOC.png";

export const HERO_CONSTANTS = {
  button: {
    label: "Get 24/7 Network Support",
    link: "contact-us",
  },
  desc: "Ensure uninterrupted network performance with our dedicated NOC, SOC, and Helpdesk services. From security monitoring to issue resolution, we've got you covered.",
  title: "24/7 Network Operations, Security, and Support – Always On",
  image: HeroBg,
};
